export default "__VITE_ASSET__fKOc0TQP__"